export type InsuranceId =
  | "none"
  | "basic"
  | "standard"
  | "premium"
  | "car_basic"
  | "car_upgrade";

/** 出行人员类型（与 UI 选项 + API traveler_type 对应） */
export const TravelerRole = {
  ADULT: "成人",
  CHILD: "儿童 (6-12岁)",
  SENIOR: "老人 (60岁以上)",
  INFANT: "幼儿 (<6岁)",
} as const;

export type TravelerRoleLabel = typeof TravelerRole[keyof typeof TravelerRole];

/** 出行人员类型 → API 编号（1=成人 2=儿童 3=老人 4=幼儿） */
export const TRAVELER_ROLE_TO_API: Record<TravelerRoleLabel, number> = {
  [TravelerRole.ADULT]: 1,
  [TravelerRole.CHILD]: 2,
  [TravelerRole.SENIOR]: 3,
  [TravelerRole.INFANT]: 4,
};

export interface Traveler {
  name: string;
  type: string;
  idCard: string;
  phone?: string;
  isDriver?: boolean;
  /** 出行人库ID（用于查看详情） */
  travelerId?: number;
  /** 是否为默认出行人 */
  isDefault?: boolean;
  licenseNo?: string;
  licenseType?: string;
  licenseExpiry?: string;
  /** 身份证正面 */
  idCardFront?: string;
  /** 身份证反面 */
  idCardBack?: string;
  /** 驾照正页 */
  licenseFront?: string;
  /** 驾照副页 */
  licenseBack?: string;
}

export type ProductType = "hotel" | "car" | "tour" | "guide";

export interface ProductInfo {
  icon: string;
  name: string;
  detail: string;
  spec: string;
  price: number;
  image: string;
}

export const BRAND = "#FF6B35";
